import { render, staticRenderFns } from "./CrewSelection.vue?vue&type=template&id=a5aa2b00"
import script from "./CrewSelection.vue?vue&type=script&lang=js"
export * from "./CrewSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports